// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"app-components-modal-footer-index--footer"};